import { useState } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { createBellSchedule, type BellSchedule } from 'services/api';
import { bellScheduleCreateConfig } from './config';

interface UseBellScheduleCreateProps {
  refreshTable: () => void;
}

export const useBellScheduleCreate = ({ refreshTable }: UseBellScheduleCreateProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = useAppForm<BellSchedule>();

  const showModal = () => {
    setModalVisible(true);
    form.setFieldsValue({
      bells: bellScheduleCreateConfig.bells,
    });
  };

  const hideModal = () => {
    setModalVisible(false);
    form.resetFields();
  };

  const onSubmit = async () => {
    form.validateFields().then(async (values) => {
      await createBellSchedule(values).then(() => {
        hideModal();
        refreshTable();
      });
    });
  };

  return {
    state: { modalVisible, form },
    methods: { showModal, hideModal, onSubmit },
  };
};
